module.exports = __webpack_public_path__ + "static/media/Calibre-Light.62b8f0fd.woff";